<div class="container-fluid">
    @if( selectedWorkbook ){
        <div class="row pdf-row">

            <div class="col-md-8 pdf-name">
                {{ selectedWorkbook.workbookName}}
            </div>
            <div class="col-md-4 btn-align">
                <button type="button" (click)="goBack()" class="btn btn-default">Back</button>
                <button type="button" (click)="setDashBoard()" class="btn btn-success continue-btn-padding" [disabled]="!currentReportUrl">Set to Dashboard</button>
            </div>
        </div>
    }
    <div class="row">
        @if( currentReportUrl) {
            <iframe [src]="currentReportUrl | safe" 
                    style="width:100%; height:800px;" 
                    frameborder="0">
            </iframe>
        }
    </div>
</div>

